import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { resetValidationSchema } from './validationSchema'
import { useLocation, useNavigate } from 'react-router-dom';
import setupAxios from '../../../../lib/redux/setupAxios';

const ResetPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.search).get('token'); // get token from URL

  const [status, setStatus] = useState({}); // lifted status out of Formik

  const initialValues = {
    password: '',
    confirmPassword: '',
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    if (!token) {
      setStatus({ error: 'Invalid or missing token.' });
      setSubmitting(false);
      return;
    }

    try {
      const response = await setupAxios.post('/reset_password', {
        token,
        password: values.password,
      });

      // API response received
      setStatus({ success: 'Password has been reset successfully!' });
    } catch (error) {
      setStatus({ error: 'Failed to reset password. Please try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="Auth-form-container">
      <div className="Auth-form">
        <h1 className="Auth-form-title text-white px-4 py-5">Reset Password</h1>
        <div className="Auth-form-content p-4">
          {/* Show success message and login button if reset was successful */}
          {status.success ? (
            <div className="text-center">
              <div className="text-success mb-4">{status.success}</div>
              <button
                  className="btn btn-primary w-100 mt-3"
                onClick={() => navigate('/login')}
              >
                Login
              </button>
            </div>
          ) : (
            <Formik
              initialValues={initialValues}
              validationSchema={resetValidationSchema}
              validateOnMount
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid }) => (
                <Form>
                  <div className="mb-3">
                    <label>New Password</label>
                    <Field
                      type="password"
                      name="password"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger mt-1"
                    />
                  </div>

                  <div className="mb-3">
                    <label>Confirm Password</label>
                    <Field
                      type="password"
                      name="confirmPassword"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="confirmPassword"
                      component="div"
                      className="text-danger mt-1"
                    />
                  </div>

                  {status?.error && (
                    <div className="text-danger mt-2 text-center">{status.error}</div>
                  )}

                  <button
                    type="submit"
                    className="btn btn-primary w-100 mt-3"
                    disabled={isSubmitting || !isValid}
                  >
                    {isSubmitting ? 'Resetting...' : 'OK'}
                  </button>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </div>
    </div>
  );
};


export default ResetPassword;
